/**
 * Area-identifier normalization (brief ING-05).
 *
 * The engine takes area ids as given, so io owns normalization before
 * matching: trim whitespace and apply Unicode NFKC. Two things are
 * deliberately NOT done here: case is preserved on the stored id
 * (county names are display text as well as keys), and zero padding is
 * never invented or stripped (7 and 007 may be different areas; a
 * mismatch is proposed to the user by the match report, never applied
 * silently). `areaMatchKey` supplies the case-folded comparison form
 * for cross-file matching in later blocks.
 */
export function normalizeAreaId(value) {
    if (typeof value === 'number') {
        return String(value);
    }
    return value.normalize('NFKC').trim();
}
/** Case-folded comparison key for matching ids across files (ING-05). */
export function areaMatchKey(value) {
    return normalizeAreaId(value).toLowerCase();
}
//# sourceMappingURL=normalize.js.map